import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import '../../Layouts/UserMasterLayout/UserMasterLayout.css';
import UserSideBar from '../../subscreens/CustomerSideBar/CustomerSideBar';
import MyNavbar from '../../components/Customer/Mynavbar/MyNavbar';
import Footer from '../../components/Customer/Footer/Footer';
import { Menu, X } from 'lucide-react';
import { useContext } from 'react';
import AppContext from '../../context/AppContext';


const UserMasterLayout = ({children}) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  
  return (
    <div className="user-layout-wrapper">
      {/*  Navbar (Full Width, Top) — MyNavbar bilkul as-is, koi prop nahi di */}
      <header className="user-navbar">
        <MyNavbar />
      </header>

      {/*  Main Content Area (Sidebar + Page Outlet) */}
      <div className="user-dashboard-container">

        {/* Customer sidebar ka apna hamburger - sirf mobile par dikhega */}
        <button
          type="button"
          className="user-sidebar-toggle-btn"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'}
        >
          {isSidebarOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        {/* Mobile overlay - sidebar khuli ho to background dark ho aur click se band ho */}
        {isSidebarOpen && (
          <div className="user-sidebar-overlay" onClick={closeSidebar}></div>
        )}

        {/* Left Sidebar (always left, off-canvas on mobile) */}
        <aside className={`user-sidebar-section ${isSidebarOpen ? 'user-sidebar-open' : ''}`}>
          <UserSideBar onNavigate={closeSidebar} /> {/*Sidebar har page pe same rahega*/}
        </aside>

        {/* Right Main Area */}
        <main className="user-main-section">
          {children} {/* Page content yahan dynamically load hoga */}
        </main>
      </div>

      {/*  Footer (Full Width, Bottom) */}
      <footer className="user-footer">
        <Footer />
      </footer>
    </div>
  );
};

export default UserMasterLayout;